import {
  fetchAll,
  fetchFiltered,
  addActivesType,
  show,
  edit
} from '@/api/activestype'

const state = {
  all: [],
  isLoading: false,
  activesTypeById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const activesType = await show(id)
      commit('setActivesTypeById', activesType)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const activesTypes = await fetchAll()
      commit('setAll', activesTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const activesTypes = await fetchFiltered(queriesParams)
      commit('setAll', activesTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addActivesType(data)
      return true
    } catch (e) {
      const msg = e.message === 'prefixAlreadyExists'
        ? { message: 'Tipo de ativo/Prefixo já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      const msg = e.message === 'prefixAlreadyExists'
        ? { message: 'Tipo de ativo/Prefixo já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.activesTypeById = null
  },

  setAll (state, activesType) {
    state.all = activesType
  },

  setActivesTypeById (state, activesType) {
    state.activesTypeById = activesType
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
